import React, { memo } from 'react';
import { connect } from 'react-redux';
;
import { Link } from 'react-router-dom';
import propTypes from 'prop-types';

import { getBreadcrumbs } from 'src/ui';
import { getUser } from 'src/user';
import { Breadcrumb, BreadcrumbItem } from 'src/ui/mui-ui-kit'

function BreadcrumbsInternal({ breadcrumbs, user }) {
  return (
    <Breadcrumb>
      {/* TODO: restore Overview when the page is done */}
      {process.env.NODE_ENV === 'development' && user.isBankAdmin && (
        <BreadcrumbItem isActive={breadcrumbs.length < 1}>
          <Link to="/">Overview</Link>
        </BreadcrumbItem>
      )}
      {breadcrumbs.map((item, index) => (
        <BreadcrumbItem
          isActive={index === breadcrumbs.length - 1}
          key={item.href}
        >
          <Link to={item.href}>{item.label}</Link>
        </BreadcrumbItem>
      ))}
    </Breadcrumb>
  );
}

BreadcrumbsInternal.propTypes = {
  breadcrumbs: propTypes.arrayOf(
    propTypes.shape({
      label: propTypes.string.isRequired,
      href: propTypes.string.isRequired,
    })
  ).isRequired,
  user: propTypes.object.isRequired,
};

const mapStateToProps = state => ({
  breadcrumbs: getBreadcrumbs(state),
  user: getUser(state),
});

export const Breadcrumbs = connect(
  mapStateToProps,
  {}
)(memo(BreadcrumbsInternal));
